import React from 'react';
import IssueForm from '../../components/Issues/IssueForm';

const IssueCreate = () => {
  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-3xl font-bold text-gray-900">Create New Issue</h1>
      <IssueForm />
    </div>
  );
};

export default IssueCreate;


